export class TemplateGroup {
    id: number;
    name: string;
    companyId: number;
    isDeleted: boolean;
}

export class PageTemplate {
    id: number;
    name: string;
    previewImageKey: number;
    description: string;
    pageTemplateGroups: TemplateGroup[];
    showImage?: boolean;
    isDeleted: boolean;
}

export class Category {
    id: number;
    name: string;
    iconAssetId: number;
    companyId: number;
    vBuilderTemplates: VBuilderTemplate[];
    categoryAssetUrl: string;
    showImage?: boolean;
}

export class VBuilderTemplate {
    id: number;
    vbuilderCatId: number;
    orderId: number;
    actionName: string;
    tutorialLink: string;
    actionDescription: string;
    pageTemplateId: number;
    pageIconAssetId: number;
}

export class Company {
    id: number;
    name: string;
    notes: string;
    assetId: number;
    emailContact: string;
    hasAutomaticUserAccess: boolean;
    autoCreateSAMLUsers: boolean;
    enableReporting: boolean;
    hasVBuilderAccess: boolean;
    isTutorialCompany: boolean;
    isMarketingCompany: boolean;
    subDomain: string;
    customCss: string;
    enableCustomFonts: boolean;
    customFonts: string;
    isEmbededFonts: boolean;
    hideUserCreation: boolean;
    isActive: boolean;
    isDemoCompany: boolean;
    hasCoachingAccess: boolean;
    idleTimeOut: number;
    allowManagerRepHierarchy: boolean;
    lockUpload: boolean;
    desiredName: string;
    isDeleted: boolean;
    supportedAuthMethods: any[];
    playbookCount: number;
    profileCount: number;
    companyEmailTemplate: any;
}

export class ContentNotification {
    id: number;
    playbookId: number;
    companyId: number;
    contents: string;
    startDate: string;
    endDate: string;
    hasDismissed: boolean;
}

export interface HTMLInputEvent {
    target: HTMLInputElement & EventTarget;
}
